import apiClient from './client';

// システム管理者認証API
export const adminAuthApi = {
  // システム管理者ログイン
  adminLogin: async (credentials) => {
    // システム管理者専用のエンドポイントを使用
    const response = await apiClient.post('/auth/system-admin/login', credentials);
    return response;
  },

  // システム管理者ログアウト
  adminLogout: async () => {
    try {
      await apiClient.post('/auth/system-admin/logout');
      return { success: true };
    } catch (error) {
      // ログアウトAPIエラーは無視して成功として扱う
      console.error('System admin logout API error:', error);
      return { success: true };
    }
  },

  // システム管理者トークンリフレッシュ
  refreshAdminToken: async (refreshToken) => {
    const response = await apiClient.post('/auth/system-admin/refresh', { refreshToken });
    return response;
  },

  // システム管理者情報取得
  getAdminInfo: async () => {
    const response = await apiClient.adminRequest('/auth/system-admin/me');
    return response;
  },

  // システム管理者パスワード変更
  changeAdminPassword: async (oldPassword, newPassword) => {
    const response = await apiClient.post('/auth/system-admin/change-password', {
      oldPassword,
      newPassword
    });
    return response;
  }
};

// 一般ユーザー認証API（既存のAuthContext用）
export const authApi = {
  // ユーザーログイン
  login: async (credentials) => {
    const response = await apiClient.post('/auth/login', credentials);
    return response;
  },

  // ユーザーログアウト
  logout: async () => {
    try {
      await apiClient.post('/auth/logout');
      return { success: true };
    } catch (error) {
      console.error('Logout API error:', error);
      return { success: true };
    }
  },

  // トークンリフレッシュ
  refreshToken: async (refreshToken) => {
    const response = await apiClient.post('/auth/refresh', { refreshToken });
    return response;
  },

  // ユーザー情報取得
  getUserInfo: async () => {
    const response = await apiClient.get('/auth/me');
    return response;
  }
};
